import * as React from "react";

/**
 * The stored trigger the form is editing, or null on the create form. Read by
 * a target that offers to become an ingestion rule, so the rule can offer to
 * disable the trigger it replaces.
 */
export const StoredTriggerContext = React.createContext<{
  triggerId: string;
} | null>(null);
